//=================================================
//    summary: DCP Time 分頁 -- Hook
//
//    remarks: 000 Tim 2021/11/16 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssTime from './Time.module.scss'
import './Time.css'

import { SwitchValueEnum } from '../Content/Content.js'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import {LocalStorageLibs, GlobalLibs, NetworkLibs, TimeZoneLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mobjTick = null
// #endregion Member Variables


const COMP_NAME = "Time"

function Time(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [anchorEl4TimeZone, setAnchorEl4TimeZone] = useState(null)
    const [timeZoneIndex, setTimeZoneIndex] = useState(0)
    const [timeDST, setTimeDST] = useState(0)
    const [instantTime, setInstantTime] = useState("")
    // #endregion Init State

    // #region Init Ref
    let mrefTimeZoneDropdown = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            clearInterval(mobjTick)
            mobjTick = null
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: Content頁面 點選 Submit
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ContentSubmitOnTapHandler(StateTimeZoneIndex, StateTimeDST)
    {
        console.log(COMP_NAME + ".ContentSubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".Preferences", window.gSession.Acc.Preferences);

        let arrPref = []
        let objPref = {}

        let intTimeZoneIndex = parseInt(window.gSession.Acc.Preferences.TimeZone) - 1

        // TimeZoneIndex
        if (StateTimeZoneIndex !== intTimeZoneIndex)
        {
            window.gSession.Acc.Preferences.TimeZone = StateTimeZoneIndex + 1

            objPref = {
                "Key": window.gAccPreferenceTypeEnum.TimeZone,
                "Value": window.gSession.Acc.Preferences.TimeZone
            };
            arrPref.push(objPref)
        } // end of if (StateTimeZoneIndex !== intTimeZoneIndex)

        // TimeDST
        if (StateTimeDST !== window.gSession.Acc.Preferences.DST)
        {
            window.gSession.Acc.Preferences.DST = StateTimeDST     // 1.On; 2.Off (default)

            objPref = {
                "Key": window.gAccPreferenceTypeEnum.DST,
                "Value": window.gSession.Acc.Preferences.DST
            };
            arrPref.push(objPref)
        } // end of if (StateTimeDST !== window.gSession.Acc.Preferences.DST)

        if (arrPref.length > 0)
        {
            ExecuteSubmit(arrPref)
        }
        else
        {
            ExecuteSubmitSuccessAlert()
        }
    } // end of ContentSubmitOnTapHandler

    /*===========================================
    summary: 點選 Switch元件 OFF / ON
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SwitchButtonOnTapHandler(SwitchValue)
    {
        console.log(COMP_NAME + ".SwitchButtonOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setTimeDST(SwitchValue)
    } // end of SwitchButtonOnTapHandler
    // #end region OnTapHandler

    // #region Other Handler
    // ====== BEGIN TimeZone下拉選單 ======
    /*===========================================
    summary: 點選 TimeZone 選單
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function TimeZoneDropdownOnTapHandler(event, StateTimeZoneIndex)
    {
        console.log(COMP_NAME +  ".TimeZoneDropdownOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setAnchorEl4TimeZone(event.currentTarget)

        // 開啟 下拉選單時，滾動到 所選擇的位置      Tim20.12.11
        // 滾動位置 Index * 元件高度
        let intOffsetTop = StateTimeZoneIndex * 36
        let objMenuDom = mrefTimeZoneDropdown.current.querySelector(".MuiMenu-paper")
        objMenuDom.scroll({
            top: intOffsetTop,
            left: 0
        })
    } // end of TimeZoneDropdownOnTapHandler

    /*===========================================
    summary: 關閉TimeZone 下拉選單
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function TimeZoneDropdownCloseEventHandler()
    {
        console.log(COMP_NAME +  ".TimeZoneDropdownCloseEventHandler")

        setAnchorEl4TimeZone(null)
    } // end of TimeZoneDropdownCloseEventHandler

    /*===========================================
    summary: 點選 TimeZone 下拉選單 選項
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function TimeZoneItemOnTapHandler(StateTimeZoneIndex, TimeZoneIndex)
    {
        console.log(COMP_NAME +  ".TimeZoneItemOnTapHandler: TimeZoneIndex: ", TimeZoneIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateTimeZoneIndex !== TimeZoneIndex)
        {
            setTimeZoneIndex(TimeZoneIndex)
        }

        TimeZoneDropdownCloseEventHandler()
    } // end of TimeZoneItemOnTapHandler
    // ====== END TimeZone下拉選單 ======
    // #endregion Other Handler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        InitStateMemberVariables()
        TickEventHandler()
        mobjTick = setInterval(TickEventHandler, 1000)
    } // end of PaintedMe

    /*===========================================
    summary: 初始化 State 變數
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function InitStateMemberVariables()
    {
        console.log(COMP_NAME + ".InitStateMemberVariables Acc.Preferences: ", window.gSession.Acc.Preferences)

        let intTimeZoneIndex = 0
        let intTimeDST = SwitchValueEnum.OFF

        if (
            (typeof(window.gSession.Acc.Preferences.TimeZone) !== 'undefined') &&
            (window.gSession.Acc.Preferences.TimeZone !== null) &&
            (window.gSession.Acc.Preferences.TimeZone !== -1)
            )
        {
            intTimeZoneIndex = parseInt(window.gSession.Acc.Preferences.TimeZone) - 1;
        }
        else
        {
            let objNow = new Date()
            let intMinutesOffset =  objNow.getTimezoneOffset() / -1
            if (window.gSession.App.MinutesOffset !== intMinutesOffset)
            {
                window.gSession.App.MinutesOffset = intMinutesOffset
            }
            intTimeZoneIndex = TimeZoneLibs.GetAccPreferenceTimeZoneIndexByTimeZoneOffset(intMinutesOffset)
        }

        if (
            (typeof(window.gSession.Acc.Preferences.DST) !== 'undefined') &&
            (window.gSession.Acc.Preferences.DST !== null) &&
            (parseInt(window.gSession.Acc.Preferences.DST) > -1)
            )
        {
            intTimeDST = parseInt(window.gSession.Acc.Preferences.DST)
        }

        console.log(COMP_NAME + ".InitStateMemberVariables intTimeZoneIndex: ", intTimeZoneIndex)
        console.log(COMP_NAME + ".InitStateMemberVariables intTimeDST: ", intTimeDST)
        console.log(COMP_NAME + ".InitStateMemberVariables window.gSession.App.MinutesOffset: ", window.gSession.App.MinutesOffset)

        setTimeZoneIndex(intTimeZoneIndex)
        setTimeDST(intTimeDST)
    } // end of InitStateMemberVariables

    /*===========================================
    summary: 時間 計時 EventHandler
    remarks: 000 Tim 2021/11/16 Create
             001 Tim 2021/12/23 將程式整合到 Globals.GetUTCTime
    ===========================================*/
    function TickEventHandler() 
    {
        let datLocalTime = new Date()
        let intUTCTime = window.Globals.GetUTCTime(datLocalTime)

        let datDisplay = new Date()
        datDisplay.setTime(intUTCTime + (window.gSession.App.MinutesOffset * 60000))

        let strNow = GlobalLibs.FormateBCDisplayDateTime(datDisplay)

        // 只取得 hh:mm:ss
        let strDisplayTime = strNow.split(" ")[1]

        setInstantTime(strDisplayTime)
    } // end of TickEventHandler

    /*===========================================
    summary: 跳出 送出成功 提示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ExecuteSubmitSuccessAlert()
    {
        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_SubmitSuccess,
            ShowCloseButton: false,
            CallbackRef: null,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of ExecuteSubmitSuccessAlert

    /*===========================================
    summary: 送出設定 
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ExecuteSubmit (AccPreferencesArray)
    {
        console.log(COMP_NAME + ".ExecuteSubmit AccPreferencesArray: ", AccPreferencesArray)

        if (AccPreferencesArray.length > 0)
        {
            mobjCallParam = {
                "AccPreferences": AccPreferencesArray
            }

            if (navigator.onLine)
            {
                SetAccountPreferences()
            }
            else
            {
                SetAccountPreferencesAfterProcess()
            }
        }
        else
        {
            ExecuteSubmitSuccessAlert()
        }
    } // end of ExecuteSubmit
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 切換按鈕 OFF / ON Cls
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function GetSwitchButtonCls(StateShowValue, SwitchValue)
    {
        let objCls = cssTime.btnSwitchOFF

        if (SwitchValue === SwitchValueEnum.OFF)
        {
            // OFF
            if (StateShowValue === SwitchValueEnum.OFF)
            {
                objCls = cssTime.btnSwitchOFFSelected
            }
            else
            {
                objCls = cssTime.btnSwitchOFF
            }
        }
        else
        {
            // ON
            if (StateShowValue === SwitchValueEnum.ON)
            {
                objCls = cssTime.btnSwitchONSelected
            }
            else
            {
                objCls = cssTime.btnSwitchON
            }
        }

        return objCls
    } // end of GetSwitchButtonCls

    /*===========================================
    summary: 取得 切換按鈕文字 OFF / ON Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetSwitchTextCls(StateShowValue, SwitchValue)
    {
        let objCls = cssTime.divSwitchText

        if (SwitchValue === StateShowValue)
        {
            objCls = cssTime.divSwitchTextSelected
        }

        return objCls
    } // end of GetSwitchTextCls

    /*===========================================
    summary: 取得 TimeZone元件 Cls
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function GetTimeZoneUnitCls(StateTimeZoneIndex, TimeZoneIndex) 
    {
        let objCls = cssTime.divTimeZoneItem

        if (StateTimeZoneIndex === TimeZoneIndex)
        {
            objCls = cssTime.divTimeZoneSelected
        }

        return objCls
    } // end of GetTimeZoneUnitCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 儲存 帳號設定後 的 流程
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SetAccountPreferencesAfterProcess ()
    {   
        console.log(COMP_NAME + ".GetAccountDashboardAfterProcess")

        // save to local storage
        LocalStorageLibs.SetAccLSElement("Preferences", JSON.stringify(window.gSession.Acc.Preferences))

        // 重新塞入數值，以防因為 Relogin導致 window.gSession.Acc.Preferences 還原    Tim17.01.12
        let intIndex = 0
        let intCount = mobjCallParam.AccPreferences.length
        for (intIndex = 0; intIndex < intCount; intIndex++)
        {   
            switch (parseInt(mobjCallParam.AccPreferences[intIndex].Key))
            {
                case window.gAccPreferenceTypeEnum.TimeZone:
                    window.gSession.Acc.Preferences.TimeZone = mobjCallParam.AccPreferences[intIndex].Value
                    break
                case window.gAccPreferenceTypeEnum.DST:
                    window.gSession.Acc.Preferences.DST = mobjCallParam.AccPreferences[intIndex].Value
                    break
                default:
                    break
            }
        } // end of for (intIndex = 0;

        window.gSession.App.MinutesOffset = TimeZoneLibs.GetMinutesOffset(window.gSession.Acc.Preferences.TimeZone, window.gSession.Acc.Preferences.DST)

        console.log(COMP_NAME + ".SetAccountPreferencesAfterProcess window.gSession.App.MinutesOffset: ", window.gSession.App.MinutesOffset)

        ExecuteSubmitSuccessAlert()

        mobjCallParam = null
    } // end of SetAccountPreferencesAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 儲存 帳號設定 
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SetAccountPreferences ()
    {
        let objRetryFuncRef = SetAccountPreferences
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SetAccountPreferencesCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SetAccountPreferences)

            let objCallData = {
                "Func": "SetAccountPreferences",
                "PrefList": JSON.stringify(mobjCallParam.AccPreferences)
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SetAccountPreferences

    /*===========================================
    summary: 儲存 帳號設定 Callback
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SetAccountPreferencesCallback (Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SetAccountPreferences_No
        let strErrorTitle = window.gAppUI.ERR_SetAccountPreferences_Title
        let strErrMsg = window.gAppUI.ERR_SetAccountPreferences_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    GlobalLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SetAccountPreferencesCallback: ErrNo: ", Return.ErrNo)
            console.log("SetAccountPreferencesCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SetAccountPreferencesCallback Return.Data: ", Return.Data)

            SetAccountPreferencesAfterProcess()
        }
    } // end of SetAccountPreferencesCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Switch Button 顯示Component  
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ComponentSwitchButton( {StateShowValue, SwitchValue} )
    {   
        let strButtonText = ""

        if (SwitchValue === SwitchValueEnum.OFF)
        {
            // Major
            strButtonText = window.gAppUI.BTN_OFF
        }
        else
        {
            // Minor
            strButtonText = window.gAppUI.BTN_ON
        }

        return(
            <div className={GetSwitchButtonCls(StateShowValue, SwitchValue)} 
                    onClick={() => SwitchButtonOnTapHandler(SwitchValue)}>
                <div className={GetSwitchTextCls(StateShowValue, SwitchValue)} >
                    {strButtonText}
                </div>
            </div> 
        )
    } // end of ComponentSwitchButton

    /*===========================================
    summary: Content Submit Row 顯示Component  
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ComponentContentSubmitRow( {StateTimeZoneIndex, StateTimeDST} )
    {   
        return(
            <div className={cssTime.divRowMain4Submit}>
                <div className={cssTime.btnSubmit} 
                        onClick={() => ContentSubmitOnTapHandler(StateTimeZoneIndex, StateTimeDST)}>
                    {window.gAppUI.BTN_Submit}
                </div>
            </div>
        )
    } // end of ComponentContentSubmitRow
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render DST Row 顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderContentDSTRowWrapper()
    {   
        return(
            <div className={cssTime.divRowMain}>
                <div className={cssTime.divRowTitle}>
                    {window.gAppUI.LBL_DST}
                </div>

                <div className={cssTime.divSwitchButtonBG}>
                    <ComponentSwitchButton StateShowValue={timeDST} SwitchValue={SwitchValueEnum.OFF} />
                    <ComponentSwitchButton StateShowValue={timeDST} SwitchValue={SwitchValueEnum.ON} />
                </div>                        
            </div>
        )
    } // end of RenderContentDSTRowWrapper

    /*===========================================
    summary: Render TimeZone 下拉 選單 選項
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderTimeZoneListWrapper(StateTimeZoneIndex)
    {
        return(
            <div>
                {TimeZoneLibs.TimeZoneList.map((TimeZoneData, TimeZoneIndex) =>
                    <MenuItem key={TimeZoneIndex} className={GetTimeZoneUnitCls(StateTimeZoneIndex, TimeZoneIndex)} onClick={() => TimeZoneItemOnTapHandler(StateTimeZoneIndex, TimeZoneIndex)}>
                        {TimeZoneData.Value}
                    </MenuItem>
                )}
            </div>
        )
    } // end of RenderTimeZoneListWrapper

    /*===========================================
    summary: Content Time Zone Dropdown Main 顯示Component  
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderTimeZoneDropdownMainWrapper(StateTimeZoneIndex)
    {   
        let strTimeZone = TimeZoneLibs.TimeZoneList[StateTimeZoneIndex].Value

        return(
            <div className={cssTime.divTimeZoneDropdownMain} aria-controls="menuTimeZone" 
                    onClick={(evnet) => TimeZoneDropdownOnTapHandler(evnet, StateTimeZoneIndex)}>
                <div className={cssTime.divTimeZoneDropdown}>
                    {strTimeZone}
                </div>
                <div className={cssTime.divTimeZoneDropdownIconMain}>
                    <div className={cssTime.divTimeZoneDropdownIcon}/>
                </div>
            </div>
        )
    } // end of RenderTimeZoneDropdownMainWrapper

    /*===========================================
    summary: Render TimeZone 下拉 選單
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderTimeZoneWrapper(StateTimeZoneIndex)
    {
        return(
            <div className={cssTime.divRowMain}>
                <div className={cssTime.divRowTitle}>
                    {window.gAppUI.LBL_TimeZone}
                </div>
                <div className={cssTime.divTimeZone}>
                    {RenderTimeZoneDropdownMainWrapper(StateTimeZoneIndex)}

                    <Menu id="menuTimeZone" ref={mrefTimeZoneDropdown} 
                        anchorEl={anchorEl4TimeZone} keepMounted 
                        open={(anchorEl4TimeZone === null) ? false : true}
                        onClose={() => TimeZoneDropdownCloseEventHandler()}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center'
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center'
                        }}
                        className={cssTime.menuTimeZone}
                    >
                        {RenderTimeZoneListWrapper(StateTimeZoneIndex)}
                    </Menu>
                </div>
            </div>
        )
    } // end of RenderTimeZoneWrapper

    /*===========================================
    summary: Render 標題 與 現在時間顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderTitleAndInstantTimeWrapper(StateInstantTime)
    {
        return(
            <>
                <div className={cssTime.divTitleMain}>
                    <div className={cssTime.divContentTitle}>
                        {window.gAppUI.LBL_Time}
                    </div>
                    <div className={cssTime.divTimeText}>
                        {StateInstantTime}
                    </div>
                </div>

                <div className={cssTime.divTitleLine}/>
            </>
        )
    } // end of RenderTitleAndInstantTimeWrapper

    /*===========================================
    summary: Render Time 內容 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                <ComponentContentSubmitRow StateTimeZoneIndex={timeZoneIndex} StateTimeDST={timeDST}/>

                {RenderTitleAndInstantTimeWrapper(instantTime)}

                {RenderTimeZoneWrapper(timeZoneIndex)}

                {RenderContentDSTRowWrapper()}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                {RenderContentWrapper()}
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default Time